import { render } from "./InventoryItems.vue?vue&type=template&id=caff8026"
import script from "./InventoryItems.vue?vue&type=script&lang=js"
export * from "./InventoryItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__